import { PageContainer } from '../../containers/PageContainer/PageContainer';
import { Copy } from '../../copy/Copy';
import { ChatGPT } from '../../icons/ChatGPT/ChatGPT';
import { Box, List, useTheme } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  coachContainerSx,
  marginRight8Sx,
  padding12Sx,
} from '../../styles/Global.style';
import { Loading } from '../../components/Loading/Loading';
import { GPT } from '../../components/GPT/GPT';
import { ListItemTile } from '../../components/ListItemTile/ListItemTile';
import { mapCoachResponseListItems } from '../../helpers/mapCoachResponseListItems';
import { useChatGPT } from '../../hooks/useChatGPT/useChatGPT';
import { Fade } from '../../components/Fade/Fade';
import { useState } from 'react';

export const CoachResponse = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const prompt = location.state.prompt;
  const { response, isLoading, generateMore } = useChatGPT(prompt);
  const [isIn, setIsIn] = useState();

  return (
    <PageContainer
      title={Copy.generate('Global.coach')}
      logo={<ChatGPT sx={marginRight8Sx} />}
    >
      {!isLoading ? (
        <Box component="div" sx={coachContainerSx}>
          <GPT
            height={250}
            typeString={response}
            callback={() => setIsIn(true)}
          />

          <List sx={padding12Sx}>
            {mapCoachResponseListItems(generateMore, navigate, theme).map(
              (l, i) => (
                <Fade isIn={isIn} i={i} key={i}>
                  <ListItemTile
                    key={i}
                    text={Copy.generate(`GPT.prompts.${l.name}`)}
                    icon={l.icon}
                    onClick={l.onClick}
                  />
                </Fade>
              ),
            )}
          </List>
        </Box>
      ) : (
        <Loading />
      )}
    </PageContainer>
  );
};
